module.exports = __webpack_public_path__ + "static/media/offlineRewardClaim.8a2064f0.svg";